import * as track from 'lib/gaTracking/bookingListPageEvents';
import { CardProps } from '../types';
import { CardWrapper, InfoWrapper, Heading, StayInfo, Hr, ItemLinks } from '../Components';
import { useBookingList } from 'pages/BookingListPage/BookingListProvider';

const CancelledBookingCard = ({ booking, trackViewBookingItem, ...rest }: CardProps) => {
  const { sendViewBookingEvent } = useBookingList();
  const {
    id,
    links,
    reservation: { property },
  } = booking;

  const detailsLink = {
    label: 'View details',
    url: links.manage,
    onClick: () => {
      track.viewDetailsLink(booking);
      sendViewBookingEvent(id);
    },
  };

  return (
    <CardWrapper>
      <InfoWrapper bookingId={booking.id} {...rest}>
        <Heading>{property.name}</Heading>
        <StayInfo booking={booking} />
      </InfoWrapper>

      <Hr />

      <ItemLinks links={[detailsLink]} />
    </CardWrapper>
  );
};

CancelledBookingCard.displayName = 'CancelledBookingCard';

export { CancelledBookingCard };
